import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "icon", "iconScale", "height", "width", "children", "round"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import styled from 'styled-components';
import { pxToRem } from 'utils/ui/units';
import { spacing } from 'styles/globals';
import { centerChildren } from 'styles/mixins';
import Icon from 'components/Icon';
import Spinner from 'components/Spinner';
import Heading from 'components/Heading';
import Text from 'components/Text';
import IconDisc from 'components/IconDisc';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled.div.withConfig({
  displayName: "Landmark__Wrapper",
  componentId: "sc-1wfri4b-0"
})(["", " max-width:", ";height:", ";flex:1 1 auto;margin:0 auto;padding:", ";"], centerChildren, function (p) {
  return pxToRem(p.width || 400);
}, function (p) {
  return p.height ? pxToRem(p.height) : '100%';
}, spacing.xs);
var Content = styled.div.withConfig({
  displayName: "Landmark__Content",
  componentId: "sc-1wfri4b-1"
})(["text-align:center;color:", ";& > * + *{margin-top:", ";}"], function (p) {
  return p.theme.text;
}, spacing.xs);
var Landmark = function Landmark(_ref) {
  var title = _ref.title,
    icon = _ref.icon,
    _ref$iconScale = _ref.iconScale,
    iconScale = _ref$iconScale === void 0 ? 2 : _ref$iconScale,
    height = _ref.height,
    width = _ref.width,
    children = _ref.children,
    round = _ref.round,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var iconEl = icon && (icon === 'spinner' ? /*#__PURE__*/_jsx(Spinner, {
    dimmed: true
  }) : round ? /*#__PURE__*/_jsx(IconDisc, {
    shady: true,
    name: icon,
    scale: iconScale
  }) : /*#__PURE__*/_jsx(Icon, {
    dimmed: true,
    name: icon,
    scale: iconScale
  }));
  return /*#__PURE__*/_jsx(Wrapper, _objectSpread(_objectSpread({}, otherProps), {}, {
    width: width,
    height: height,
    children: /*#__PURE__*/_jsxs(Content, {
      children: [iconEl, title && /*#__PURE__*/_jsx(Heading, {
        as: "h2",
        children: title
      }), children && /*#__PURE__*/_jsx(Text, {
        as: "div",
        children: children
      })]
    })
  }));
};
export default Landmark;